
function calculateAvailableEquityRent(propertyValue, outstandingLoanBalance) {
  return propertyValue * 0.8 - outstandingLoanBalance;
}

function calculateAvailableEquitySell(propertyValue, outstandingLoanBalance, sellingAgentFee, conveyancingFee, otherCosts) {
  return propertyValue - outstandingLoanBalance - sellingAgentFee - conveyancingFee - otherCosts;
}

function calculateNewLoanBalance(outstandingLoanBalance, availableEquity) {
  return outstandingLoanBalance + availableEquity;
}

function calculateNewMonthlyRepayment(interestRate, remainingLoanTerm, newLoanBalance) {
  const rate = interestRate / 12;
  const numberOfPeriods = remainingLoanTerm * 12;
  const presentValue = newLoanBalance;
  const futureValue = 0;
  const type = 0;
  // $PMT = (-$fv - $pv * pow(1 + $rate, $nper)) / (1 + $rate * $type) / ( (pow(1 + $rate, $nper) - 1) / $rate);
  const pmt = (-futureValue - presentValue * ((1 + rate) ** numberOfPeriods)) / (1 + rate * type) / ( ((1 + rate) ** numberOfPeriods - 1) / rate);
  return - pmt;
}

export function returnEquityCalculatorOutput(inputs) {
  if (inputs.propertyIntent === 'rent') {
    const availableEquity = calculateAvailableEquityRent(inputs.propertyValue, inputs.outstandingLoanBalance);
    const newLoanBalance = calculateNewLoanBalance(inputs.outstandingLoanBalance, availableEquity);
    const newMonthlyRepayment = calculateNewMonthlyRepayment(inputs.interestRate, inputs.remainingLoanTerm, newLoanBalance);

    return {
      availableEquity,
      newLoanBalance,
      newMonthlyRepayment,
    }
  } else {
    const availableEquity = calculateAvailableEquitySell(inputs.propertyValue, inputs.outstandingLoanBalance, inputs.sellingAgentFee, inputs.conveyancingFee, inputs.otherCosts);
    return {
      availableEquity,
    }
  }
  
}
